import { render } from "./IntertextFull.vue?vue&type=template&id=56e78cef&ts=true"
import script from "./IntertextFull.vue?vue&type=script&lang=ts"
export * from "./IntertextFull.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__